<template>
    <div class="subscribe">
        <a :href="getRoutePath(routeName)" v-on:click.prevent="onNavItemClick(routeName, scrollToSubscriptionWidget)">
            Subscribe to all the latest news
        </a>
    </div>
</template>

<script>
/* Mixins */
import { mixinRoutesHandler } from '@/mixins/routes-handler';

export default {
    mixins: [mixinRoutesHandler],

    data() {
        return {
            scrollToSubscriptionWidget: true,
            routeName: 'InvestorRelationsContact',
        }
    },
    methods: {
        getRoutePath(routeName) {
            return this._mixinGetRoutePath(routeName);
        },

        onNavItemClick(routeName, scrollToSubscriptionWidget) {
            this.$router.push({
                name: routeName,
                params: { scrollToSubscriptionWidget: scrollToSubscriptionWidget, },
            });
        },
    }
}
</script>

<style lang="scss">
    .subscribe {
        width: 100%;
        margin-bottom: 20px;
        text-align: center;

        a {
           color: #192e5b !important;
           font-size: 1.3em;
        }
    }
</style>